import {
	GET_REVIEWS_OF_STORE,
	ADD_RATING_FOR_ORDER,
	GET_RATABLE_ORDER_DETAILS,
	GET_ITEM_RATING_SUMMARY,
} from "./actionTypes";

const initialState = {
	done_rating: [],
	order: [],
	reviews: [],
	// Map of item_id -> { avg_rating, rating_count } for the currently
	// viewed store. Empty until at least one item has a real review.
	itemRatingSummary: {},
};

export default function(state = initialState, action) {
	switch (action.type) {
		case ADD_RATING_FOR_ORDER:
			return { ...state, done_rating: action.payload };
		case GET_RATABLE_ORDER_DETAILS:
			return { ...state, order: action.payload };
		case GET_REVIEWS_OF_STORE:
			return { ...state, reviews: action.payload };
		case GET_ITEM_RATING_SUMMARY:
			return { ...state, itemRatingSummary: action.payload };
		default:
			return state;
	}
}
